import { useSyncExternalStore, type ReactNode } from "react";
import { resolveFilterRail, type FilterBookmark } from "./datasetFilterBookmarks";
import { DatasetFilterSheet } from "./DatasetFilterSheet";
import type { DatasetFilterController } from "./DatasetFilterController";
import { FilterSheetButton } from "./FilterSheetButton";

export type DatasetFilterAdvancedButtonProps = {
  controller: DatasetFilterController;
};

// 고급 필터 진입 버튼이다. 표 툴바(도구 행)에 두는 독립 컴포넌트다. 배지는 레일 밖 조건 수다
// (레일과 같은 계산을 쓴다). 컨트롤러가 시트 열림과 북마크 상태를 소유하므로 레일(DatasetFilter)과
// 항상 같은 상태다.
export function DatasetFilterAdvancedButton({
  controller,
}: DatasetFilterAdvancedButtonProps): ReactNode {
  const snapshot = useSyncExternalStore(
    controller.subscribe,
    controller.getSnapshot,
    controller.getSnapshot,
  );
  const rail = resolveFilterRail(
    snapshot.bookmarks,
    snapshot.filter.groups,
    snapshot.filter.selection,
    snapshot.labelTokens.length,
  );

  function handleToggleBookmark(entry: FilterBookmark): void {
    controller.toggleBookmark(entry);
  }

  return (
    <>
      <FilterSheetButton
        label="고급 필터"
        count={rail.outsideCount}
        open={snapshot.advancedOpen}
        onOpen={() => controller.openAdvancedSheet()}
      />
      <DatasetFilterSheet
        controller={controller}
        open={snapshot.advancedOpen}
        onClose={() => controller.closeAdvancedSheet()}
        bookmarks={snapshot.bookmarks}
        onToggleBookmark={handleToggleBookmark}
      />
    </>
  );
}
